import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=15b4fc0c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=15b4fc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4fc0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b4fc0c')) {
      api.createRecord('15b4fc0c', component.options)
    } else {
      api.reload('15b4fc0c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=15b4fc0c&scoped=true&", function () {
      api.rerender('15b4fc0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/comp/GuestBox.vue"
export default component.exports